var _metadata;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPorcentagemSucesso(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "master-artboard",
    viewBox: "0 0 503.5628967285156 446.98333740234375",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 1400 980"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.450656771659851, 0, 0, 0.450656771659851, 6.28594971711459, -3.634204098537481)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(5.343433380126952, 0, 0, 5.343433380126952, 1193.4159543153742, 1227.1260680846829)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "ee-background",
    x: 0,
    y: 0,
    width: 503.5628967285156,
    height: 446.98333740234375,
    style: {
      fill: "rgb(250, 192, 45)",
      fillOpacity: 1,
      pointerEvents: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.03664058446884155, 0, 0, 0.03664058446884155, -625.5484771728516, -369.62646484375)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_x0020_1"
  }, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  })), /*#__PURE__*/React.createElement("path", {
    className: "fil0 area_cor_padrao_grafico_direita",
    name: "sucesso-1",
    d: "M13858.51 4186.44c0,98.13 -79.56,177.71 -177.68,177.71 -98.15,0 -177.71,-79.58 -177.71,-177.71 0,-98.12 79.56,-177.7 177.71,-177.7 98.12,0 177.68,79.58 177.68,177.7z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 area_cor_padrao_grafico_direita",
    name: "sucesso-2",
    d: "M14080.71 4215.71c25.45,-94.78 122.9,-150.97 217.68,-125.64 94.79,25.45 151.09,122.88 125.72,217.69 -25.42,94.79 -122.88,150.98 -217.66,125.64 -94.78,-25.45 -151.08,-122.8 -125.74,-217.69z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 area_cor_padrao_grafico_direita",
    name: "sucesso-3",
    d: "M14631.19 4393.5c49.12,-84.96 157.77,-114.03 242.84,-65.02 84.95,49.12 114.02,157.77 65.01,242.72 -49.11,85.07 -157.85,114.14 -242.83,65.13 -84.95,-49.12 -114.02,-157.77 -65.02,-242.83z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 area_cor_padrao_grafico_direita",
    name: "sucesso-4",
    d: "M15116.83 4707.75c69.36,-69.44 181.94,-69.44 251.27,0 69.45,69.33 69.45,181.91 0,251.27 -69.33,69.33 -181.91,69.33 -251.27,0 -69.44,-69.36 -69.44,-181.94 0,-251.27z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 area_cor_padrao_grafico_direita",
    name: "sucesso-5",
    d: "M15504.65 5136.92c84.96,-49.12 193.61,-19.96 242.72,65.02 49.01,84.95 19.94,193.6 -65.01,242.72 -84.99,49.12 -193.72,19.94 -242.84,-65.02 -49,-84.98 -19.93,-193.71 65.13,-242.72z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 area_cor_padrao_grafico_direita",
    name: "sucesso-6",
    d: "M15768.09 5651.74c94.81,-25.37 192.24,30.94 217.69,125.72 25.45,94.81 -30.85,192.24 -125.64,217.69 -94.78,25.34 -192.23,-30.94 -217.68,-125.75 -25.43,-94.78 30.85,-192.24 125.63,-217.66z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 area_cor_padrao_grafico_direita",
    name: "sucesso-7",
    d: "M15889.41 6217.35c98.12,0 177.59,79.55 177.59,177.68 0,98.15 -79.47,177.7 -177.59,177.7 -98.13,0 -177.79,-79.55 -177.79,-177.7 0,-98.13 79.66,-177.68 177.79,-177.68z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 area_cor_padrao_grafico_direita",
    name: "sucesso-8",
    d: "M15860.14 6795.01c94.79,25.37 151.09,122.91 125.64,217.58 -25.45,94.9 -122.88,151.09 -217.69,125.75 -94.78,-25.45 -151.06,-122.88 -125.63,-217.69 25.45,-94.78 122.9,-151.06 217.68,-125.64z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 area_cor_padrao_grafico_direita",
    name: "sucesso-9",
    d: "M15682.36 7345.5c84.95,49.01 114.02,157.66 65.01,242.64 -49.11,85.07 -157.76,114.14 -242.72,65.02 -85.06,-49.01 -114.13,-157.66 -65.13,-242.61 49.12,-85.1 157.85,-114.17 242.84,-65.05z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 area_cor_padrao_grafico_direita",
    name: "sucesso-10",
    d: "M15368.1 7831.06c69.45,69.44 69.45,181.91 0,251.38 -69.33,69.33 -181.91,69.33 -251.27,0 -69.44,-69.47 -69.44,-181.94 0,-251.38 69.36,-69.36 181.94,-69.36 251.27,0z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 area_cor_padrao_grafico_direita",
    name: "sucesso-11",
    d: "M14939.04 8218.88c49.01,84.95 19.94,193.68 -65.01,242.72 -85.07,49.12 -193.72,19.93 -242.84,-65.05 -49,-84.95 -19.93,-193.68 65.02,-242.72 84.98,-49.12 193.72,-19.94 242.83,65.05z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 area_cor_padrao_grafico_direita",
    name: "sucesso-12",
    d: "M14424.11 8482.43c25.37,94.78 -30.93,192.12 -125.72,217.57 -94.78,25.34 -192.23,-30.85 -217.68,-125.74 -25.34,-94.7 30.96,-192.24 125.74,-217.47 94.78,-25.45 192.24,30.74 217.66,125.64z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 area_cor_padrao_grafico_direita",
    name: "sucesso-13",
    d: "M13858.51 8603.52c0,98.24 -79.56,177.82 -177.68,177.82 -98.15,0 -177.71,-79.58 -177.71,-177.82 0,-98.12 79.56,-177.59 177.71,-177.59 98.12,0 177.68,79.47 177.68,177.59z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 area_cor_padrao_grafico_direita",
    name: "sucesso-14",
    d: "M12937.63 8482.43c25.34,-94.9 122.76,-151.09 217.58,-125.64 94.78,25.23 151.05,122.77 125.63,217.47 -25.45,94.89 -122.79,151.08 -217.69,125.74 -94.78,-25.45 -150.97,-122.79 -125.52,-217.57z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 area_cor_padrao_grafico_direita",
    name: "sucesso-15",
    d: "M12422.7 8218.88c49,-84.99 157.65,-114.17 242.63,-65.05 85.07,49.04 114.14,157.77 65.02,242.72 -49,84.98 -157.65,114.17 -242.64,65.05 -85.06,-49.04 -114.13,-157.77 -65.01,-242.72z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 area_cor_padrao_grafico_direita",
    name: "sucesso-16",
    d: "M11993.44 7831.06c69.34,-69.36 181.91,-69.36 251.36,0 69.36,69.44 69.36,181.91 0,251.38 -69.45,69.33 -182.02,69.33 -251.36,0 -69.36,-69.47 -69.36,-181.94 0,-251.38z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 area_cor_padrao_grafico_direita",
    name: "sucesso-17",
    d: "M11679.3 7345.5c84.95,-49.12 193.69,-20.05 242.72,65.05 49.12,84.95 19.94,193.6 -65.04,242.61 -84.96,49.12 -193.69,20.05 -242.72,-65.02 -49.12,-84.98 -19.94,-193.63 65.04,-242.64z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 area_cor_padrao_grafico_direita",
    name: "sucesso-18",
    d: "M11501.6 6795.01c94.7,-25.42 192.24,30.86 217.46,125.64 25.45,94.81 -30.74,192.24 -125.52,217.69 -94.9,25.34 -192.24,-30.85 -217.69,-125.75 -25.34,-94.67 30.85,-192.21 125.75,-217.58z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 area_cor_padrao_grafico_direita",
    name: "sucesso-19",
    d: "M11472.33 6217.35c98.13,0 177.59,79.55 177.59,177.68 0,98.15 -79.46,177.7 -177.59,177.7 -98.23,0 -177.81,-79.55 -177.81,-177.7 0,-98.13 79.58,-177.68 177.81,-177.68z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 area_cor_padrao_grafico_direita",
    name: "sucesso-20",
    d: "M11593.54 5651.74c94.78,25.42 150.97,122.88 125.52,217.66 -25.22,94.81 -122.76,151.09 -217.46,125.75 -94.9,-25.45 -151.09,-122.88 -125.75,-217.69 25.45,-94.78 122.79,-151.09 217.69,-125.72z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 area_cor_padrao_grafico_direita",
    name: "sucesso-21",
    d: "M11856.98 5136.92c84.98,49.01 114.16,157.74 65.04,242.72 -49.03,84.96 -157.77,114.14 -242.72,65.02 -84.98,-49.12 -114.16,-157.77 -65.04,-242.72 49.03,-84.98 157.76,-114.14 242.72,-65.02z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 area_cor_padrao_grafico_direita",
    name: "sucesso-22",
    d: "M12244.8 4707.75c69.36,69.33 69.36,181.91 0,251.27 -69.45,69.33 -182.02,69.33 -251.36,0 -69.36,-69.36 -69.36,-181.94 0,-251.27 69.34,-69.44 181.91,-69.44 251.36,0z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 area_cor_padrao_grafico_direita",
    name: "sucesso-23",
    d: "M12730.35 4393.5c49.12,85.06 20.05,193.71 -65.02,242.83 -84.98,49.01 -193.63,19.94 -242.63,-65.13 -49.12,-84.95 -20.05,-193.6 65.01,-242.72 84.99,-49.01 193.64,-19.94 242.64,65.02z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 area_cor_padrao_grafico_direita",
    name: "sucesso-24",
    d: "M13280.84 4215.71c25.42,94.89 -30.85,192.24 -125.63,217.69 -94.82,25.34 -192.24,-30.85 -217.58,-125.64 -25.45,-94.81 30.74,-192.24 125.52,-217.69 94.9,-25.33 192.24,30.86 217.69,125.64z",
    style: {
      fill: "rgb(187, 194, 199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 12302.08,
    y: 5971.52,
    className: "fil1 fnt0 area_cor_fonte_grafico_direita",
    style: {
      whiteSpace: "pre",
      fill: "rgb(187, 194, 199)",
      fontWeight: "bold",
      fontSize: "564.44px",
      fontFamily: "Arial"
    }
  }, "SUCESSO")))), /*#__PURE__*/React.createElement("text", {
    className: "label camada_sucesso single-line-text percentuais sucesso_formatted area_cor_sucesso_grafico_direita",
    dominantBaseline: "middle",
    style: {
      whiteSpace: "pre",
      textAnchor: "middle",
      fill: "rgb(250, 192, 45)",
      fontWeight: "bold",
      fontSize: "183.57px",
      textAlign: "center",
      fontFamily: "Arial",
      color: "rgb(250, 192, 45)"
    },
    x: 710,
    y: 630,
    transform: "matrix(1, 0, 0, 1, -180.04503439523023, 16.36773061418853)",
    name: "sucesso_formatted"
  }, "0%")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPorcentagemSucesso);
export default __webpack_public_path__ + "static/media/porcentagem_sucesso.3467efa0b7a7fd5e4c539eb60efde62f.svg";
export { ForwardRef as ReactComponent };